// src/extenders/collection-line-handler.js
var HeaderHeightCalculator = class {
  constructor(headerSelector, stickyElementSelector) {
    this.headerElement = document.querySelector(headerSelector);
    this.stickyElement = document.querySelector(stickyElementSelector);
    this.updateHeaderHeight();
    window.addEventListener("resize", () => this.updateHeaderHeight());
  }
  updateHeaderHeight() {
    const headerHeight = this.headerElement.offsetHeight;
    this.stickyElement.style.setProperty("--header-height", `${headerHeight}px`);
  }
};
document.addEventListener("DOMContentLoaded", () => {
  new HeaderHeightCalculator("header", "[data-collection-line]");
});
